module.exports = __webpack_public_path__ + "img/screen.b81231ad.svg";